// пришлось добавить костыли, т.к. из react-router-dom v6 убрали usePrompt и useBlocker
// обсуждение здесь: https://github.com/remix-run/react-router/issues/8139
// сделал по примеру костыли: https://codesandbox.io/s/stupefied-heyrovsky-erqufz?file=/src/index.tsx:101-141

export * from './usePrompt';
export * from './PromtContext';
